module.exports = __webpack_public_path__ + "img/next-arrow.efa363d0.svg";